// FLAGS: none
// Millisecond helpers so React Query durations read as units rather than arithmetic.
export const minutes = (count: number): number => count * 60 * 1000;

export const hours = (count: number): number => minutes(count * 60);
